import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Breadcrumbs from '../components/common/Breadcrumbs';
import ShareActions from '../components/common/ShareActions';
import OrgBlock from '../components/common/OrgBlock';

const ArticoloPage = () => {
  return (
    <Layout>
      <div className="container">
        <Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'Notizie', path: '/notizie' }, { label: 'Assemblea Nazionale GD' }]} style={{ paddingTop: 'var(--space-6)' }} />
      </div>
      <article className="section section--sm">
        <div className="container">
          <div className="detail-layout">
            <div className="content-narrow">
              <div className="card__meta mb-4">
                <span className="badge badge--primary">Nazionale</span>
                <span>15 Marzo 2026</span>
                <span className="card__meta-dot"></span>
                <span>5 min di lettura</span>
              </div>
              <h1 className="h1 mb-4">Assemblea Nazionale GD: approvato il documento politico "L'Italia che vogliamo"</h1>
              <p className="text-lead mb-6">L'Assemblea Nazionale dei Giovani Democratici ha approvato all'unanimità il nuovo documento programmatico.</p>
              <div style={{ aspectRatio: '16/9', borderRadius: 'var(--radius-xl)', overflow: 'hidden', marginBottom: 'var(--space-8)' }}>
                <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop" alt="Assemblea Nazionale" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div className="flex items-center gap-4 mb-8" style={{ paddingBottom: 'var(--space-6)', borderBottom: '1px solid var(--color-border)' }}>
                <div style={{ width: 48, height: 48, borderRadius: 'var(--radius-full)', background: 'var(--color-primary-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'var(--weight-bold)', color: 'var(--color-primary)' }}>R</div>
                <div>
                  <div style={{ fontWeight: 'var(--weight-semibold)' }}>Redazione GD</div>
                  <div className="text-meta">Sede Nazionale · Roma</div>
                </div>
                <ShareActions label="Condividi" style={{ marginLeft: 'auto' }} />
              </div>
              <div className="prose">
                <p>Si è tenuta sabato 15 marzo, presso il Centro Congressi Europa di Roma, l'Assemblea Nazionale dei Giovani Democratici.</p>
                <h2>Il documento "L'Italia che vogliamo"</h2>
                <p>Il cuore dell'Assemblea è stato l'approvazione del documento politico "L'Italia che vogliamo".</p>
                <blockquote>"Non ci accontentiamo di promesse. Vogliamo politiche strutturali per il lavoro giovanile." — Marco Ferrara</blockquote>
                <h2>Le cinque priorità</h2>
                <ol>
                  <li><strong>Lavoro dignitoso</strong>: salario minimo, contrasto al precariato.</li>
                  <li><strong>Diritto all'abitare</strong>: legge quadro nazionale per affitti giovanili.</li>
                  <li><strong>Istruzione accessibile</strong>: gratuità degli studi universitari.</li>
                  <li><strong>Transizione ecologica giusta</strong>: energia rinnovabile e mobilità sostenibile.</li>
                  <li><strong>Diritti e inclusione</strong>: legge contro l'omotransfobia, ius scholae.</li>
                </ol>
                <h3>I numeri dell'Assemblea</h3>
                <ul>
                  <li>Oltre 400 delegati presenti</li>
                  <li>20 regioni rappresentate</li>
                  <li>5 tavoli tematici paralleli</li>
                  <li>Approvazione unanime del documento finale</li>
                </ul>
              </div>
              <div className="mt-8 mb-8" style={{ paddingTop: 'var(--space-6)', borderTop: '1px solid var(--color-border)' }}>
                <div className="text-label mb-3">Argomenti</div>
                <div className="tags">
                  {['Assemblea', 'Documento Politico', 'Lavoro', 'Istruzione'].map((t) => <span className="tag" key={t}>{t}</span>)}
                </div>
              </div>
              <ShareActions label="Condividi questo articolo" style={{ padding: 'var(--space-6)', background: 'var(--color-surface)', borderRadius: 'var(--radius-lg)', marginBottom: 'var(--space-8)' }} />
            </div>
            <aside>
              <OrgBlock title="Correlati" className="mb-6">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)', marginTop: 'var(--space-4)' }}>
                  {[
                    { title: 'Forum Nazionale Giovani e Lavoro', date: '22 Mar 2026', bg: 'var(--color-primary-subtle)' },
                    { title: 'Campagna "Abitare Giovane"', date: '10 Mar 2026', bg: 'var(--color-secondary)' },
                  ].map((item) => (
                    <Link to="/articolo" style={{ display: 'flex', gap: 'var(--space-3)', alignItems: 'center' }} key={item.title}>
                      <div style={{ width: 60, height: 60, background: item.bg, borderRadius: 'var(--radius-md)', flexShrink: 0, opacity: 0.2 }}></div>
                      <div>
                        <div className="text-small" style={{ fontWeight: 'var(--weight-semibold)' }}>{item.title}</div>
                        <div className="text-meta">{item.date}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </OrgBlock>
              <OrgBlock title="Newsletter">
                <p className="text-body-sm text-secondary mt-2 mb-4">Ricevi le notizie nella tua email.</p>
                <form><input type="email" className="form-input mb-3" placeholder="La tua email" /><button type="submit" className="btn btn--primary w-full btn--sm">Iscriviti</button></form>
              </OrgBlock>
            </aside>
          </div>
        </div>
      </article>
    </Layout>
  );
};

export default ArticoloPage;
